import { Routes } from '@angular/router';
import { NotFoundComponent } from './authentication/not-found/not-found.component';

export const routes: Routes = [
    { path: '', redirectTo: 'authentication/login', pathMatch: 'full' },
    {
        path: 'authentication',
        loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
    },
    {
        path: '',
        loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule),
    },
    { path: '**', component: NotFoundComponent },
];
